<template>
	<div class="col-12 px-0">
		<div class="col-12">
			<div class="d-flex align-items-center justify-content-between mb-4">
				<h4><i class="fas fa-history"></i> Histórico de atualizações de status</h4>
				<div>
					<button
						class="btn active btn-outline-secondary btn-sm"
						title="Voltar para Identificação da Família e Endereço"
						@click="$emit('voltar')"
					>
						<i class="mdi mdi-arrow-left"></i>Voltar
					</button>
				</div>
			</div>
		</div>
		<load v-if="loading" mode="table" />
		<div v-else class="col-md-12 mb-3">
			<table
				class="table table-bordered bg-white table-sm"
				v-for="historico in historicos"
				:key="historico.id"
			>
				<thead>
					<tr>
						<th>Status Atual</th>
						<th>Status Anterior</th>
						<th>Status Data Atualização</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<b>{{ historico.atual.descricao }}</b>
						</td>
						<td>
							<b>{{ historico.anterior.descricao }}</b>
						</td>
						<td>{{ historico.data_atualizacao }}</td>
					</tr>
					<tr>
						<td colspan="3">Técnico:<b v-html="historico.user_id"></b></td>
					</tr>
					<tr>
						<td colspan="3" v-html="historico.observacoes"></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	props: ["id", "familia"],
	data() {
		return {
			loading: true,
			historicos: {},
		};
	},
	mounted() {
		this.getHistorico();
	},
	methods: {
		getStatusTitulo(id) {
			let status = this.$root.arrays.beneficio_status;
			//console.log(this.$root.arrays.beneficio_status);
			//console.log(id);
			const result = status.filter((item) => item.id == parseInt(id));
			return result[0] ? result[0].value : "";
		},

		getHistorico() {
			this.loading = true;
			axios
				.get("api/dashboard/beneficio/historico/status/" + this.id)
				.then((response) => {
					this.historicos = response.data;
				})
				.finally(() => {
					this.loading = false;
				})
				.catch(() => {
					swal.fire({
						title: "Ops!",
						html: "Histórico de Status não foi carregado corretamente<br>" + error,
						icon: "error",
					});
				});
		},
	},
};
</script>
